import { useState, useRef } from "react";
import logologin from "../../../image/Logo_mark.svg"
import { Link, useNavigate } from "react-router-dom"
import { useStateContext } from "../../../Context/ContextProvider";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login() {
  const emailRef = useRef();
  const passwordRef = useRef();
  const [visible, setVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const { setToken, setUser } = useStateContext();
  const [emailErreur, setEmailErreur] = useState('');
  const [passwordErreur, setPasswordErreur] = useState('');
  const [loading, setLoading] = useState(false);
  const [loadingSuivant, setLoadingSuivant] = useState(false);
  const navigate = useNavigate();

  const handleEmailValidation = (event) => {
    event.preventDefault();
    const email = emailRef.current.value.trim();
    if (email !== "") {
      setLoadingSuivant(true)
      axios
        .post("https://catalogue.mg.formafusion.io/api/checkEmail", { email })
        .then((response) => {
          if (response.data.exists) {
            setTimeout(()=>{
              setVisible(true);
              setLoadingSuivant(false)
            },3000);

          } else {
            toast.error("Email n'existe pas, veuillez vous connecter");
            setTimeout(() => {
              navigate("/register");
            }, 4000);
          }
        })
        .catch((error) => {
          console.log(error);
          toast.error("Erreur lors de la vérification de l'email");
        });
    }
  };


  const togglePasswordVisibility = () => {
    setIsPasswordVisible(!isPasswordVisible);
  };


  const Submit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setLoading(true);

    const payload = {
      email: emailRef.current.value,
      password: passwordRef.current.value,
    };
    axios
      .post("https://catalogue.mg.formafusion.io/api/login", payload)
      .then(({ data }) => {
        localStorage.setItem("user", JSON.stringify(data.user));
        setUser(data.user);
        setToken(data.token);
        //localStorage.setItem("USER_TYPE", data.user.email === "responsable@numerika.center" ? "cfp" : "etp");
        setIsSubmitting(false);
        setLoading(false);

        if (data.redirect) {
          navigate(`/${data.redirect}`);
          console.log(data.redirect);
          toast.success("Connexion réussie !");
        } else {
          navigate('/register')
          toast.error("Veuillez vous s'inscrire");
        }

      })
      .catch((error) => {
        console.log(error);
        setIsSubmitting(false);
        setLoading(false);

        let message = "Une erreur est survenue lors de la connexion";
        let emailError = 'Utilisateur non identiifier';
        let passwordError = 'Mot de passe incorrect';

        if (error.response) {
          // Gestion des erreurs de validation Laravel typiques
          if (error.response.status === 422 && error.response.data.errors) {
            const errors = error.response.data.errors;
            emailError = errors.email ? errors.email[0] : '';
            passwordError = errors.password ? errors.password[0] : '';
          }
          // Gestion des réponses d'erreur personnalisées
          else if (error.response.data.message) {
            message = error.response.data.message;

            // Détection des erreurs spécifiques
            if (message.toLowerCase().includes('email')) {
              toast.error("Email non trouvé, veuillez vous s'inscrire")
              setTimeout(() => {
                navigate("/register");
              }, 2000);
              return;

            } else if (message.toLowerCase().includes('mot de passe')) {
              //passwordError = message;
              toast.error(passwordError)
            }

            toast.error(message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
            });
          }

        } else if (error.request) {
          message = "Aucune réponse du serveur - vérifiez votre connexion internet";
          toast.error(message)
        }

        // Mise à jour des états d'erreur
        setEmailErreur(emailError);
        setPasswordErreur(passwordError);

        // Affichage de l'erreur principale seulement si aucune erreur de champ spécifique
        if (!emailError && !passwordError && !error.response?.data.message) {
          toast.error(message);
        }
      });
  };


  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />

      <div className="flex items-center justify-center min-h-screen pt-16 px-4 bg-[#f9f9fb]">
        <div className="w-full max-w-lg bg-[#f1f1f4] rounded-xl p-6">
          <div className="flex flex-col items-center mb-6">
            <img src={logologin} alt="Logo" className="w-20 h-20" />
            <h1 className="text-xl font-extrabold text-[#A462A4] mt-3 text-center">
              Connectez-vous
            </h1>
          </div>

          <form className="bg-white p-4 rounded-xl shadow-md" onSubmit={Submit}>

            <div className="mb-4">
              <h2 className="text-xs text-gray-700 mb-1">Renseignez votre adresse email</h2>
              <input
                type="email"
                name="email"
                placeholder="votre-adresse@gmail.com"
                ref={emailRef}
                onKeyDown={(event) => {
                  if (event.key === "Enter") {
                    handleEmailValidation(event);
                  }
                }}
                disabled={isSubmitting}
                className="w-full h-10 px-3 border border-gray-200 rounded-md focus:outline-none focus:border-purple-300 focus:ring-2 focus:ring-purple-100 text-sm"
              />
              {emailErreur && <p className="text-red-600 text-xs mt-1">{emailErreur}</p>}
            </div>

            {!visible && (
              <button
                type="button"
                onClick={handleEmailValidation}
                disabled={isSubmitting}
                className="w-full py-2 px-4 bg-[#a462a4] text-white rounded-xl text-sm font-semibold hover:bg-[#A462A4]/90 transition-colors duration-200 flex justify-center items-center mb-4"
              >
                {loadingSuivant?(
                  <>
                      <svg className="animate-spin h-4 w-4 mr-2 text-white" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="white" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                      </svg>
                      <span>Vérification email...</span>
                    </>
                  ) : (
                    'Suivant'
                )}
              </button>

            )}

            {visible && (
              <>
                <p className="mt-4 text-sm text-[#A462A4] font-medium">On se connaît déjà !</p>
                <p className="text-xs text-gray-700 mb-1">Renseignez votre mot de passe</p>
                <div className="relative mb-4">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    name="password"
                    ref={passwordRef}
                    disabled={isSubmitting}
                    className="w-full h-10 px-3 pr-10 border border-gray-200 rounded-md focus:outline-none focus:border-purple-300 focus:ring-2 focus:ring-purple-100 text-sm"
                  />
                  <span
                    className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 cursor-pointer"
                    onClick={togglePasswordVisibility}
                  >
                    {isPasswordVisible ? <FaEyeSlash className="text-sm" /> : <FaEye className="text-sm" />}
                  </span>
                  {passwordErreur && <p className="text-red-600 text-xs mt-1">{passwordErreur}</p>}
                </div>

                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="w-full py-2 px-4 bg-[#a462a4] text-white rounded-xl text-sm font-semibold hover:bg-[#A462A4]/90 transition-colors duration-200 flex justify-center items-center"
                >
                  {loading ? (
                    <>
                      <svg className="animate-spin h-4 w-4 mr-2 text-white" viewBox="0 0 24 24">
                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="white" strokeWidth="4" fill="none" />
                        <path className="opacity-75" fill="white" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
                      </svg>
                      <span>Chargement...</span>
                    </>
                  ) : (
                    'Connexion'
                  )}
                </button>
              </>
            )}

          </form>

          <div className="mt-4 text-start">
            <Link to="/register" className="text-[#a462a4] underline text-xs font-semibold">
              Pas encore de compte ? Inscrivez-vous
            </Link>
          </div>
        </div>
      </div>


    </>
  );
}
